import { useState, useEffect } from 'react'
import { Form, Field, FormElement } from '@progress/kendo-react-form'
import {
  FormDropDownList,
  FormNumericTextBox,
  FormDatePicker,
  FormDropDownListFilter,
  FormTextArea,
  FormSwitch,
} from '../FormComponents'

import { getMatchingClientSite, getSitesDropdown, getTargetSite } from '../../../data/siteData'
import { getClientsDropdown } from '../../../data/clientData'
import { getEnquirysourceDropdown } from '../../../data/enquirysourceData'
import { getLikelihoodDropdown } from '../../../data/likelihoodData'
import { getWorktypeDropdown } from '../../../data/worktypeData'
import { getEmployeeDropdown } from '../../../data/employeeData'

import { dropDown } from '../../../data/interfaces'
import { requiredValidator } from '../Validators'
import Divider from '../../Layout/Divider'
import { useToast } from '../../../contexts/ToastContext'
import { getAddressesForClientDropdown, getClientsForClientsDropdown, getClientByIdV2 } from '../../../data/accountsData'
import { FaFlag } from 'react-icons/fa'

const AddQuoteForm = (props: any) => {
  const [siteData, setSiteData] = useState<dropDown[]>([])
  const [siteDataOrig, setSiteDataOrig] = useState<dropDown[]>([])
  const [clientData, setClientData] = useState<dropDown[]>([])
  const [clientDataOrig, setClientDataOrig] = useState<dropDown[]>([])
  const [enquirysourceData, setEnquirysourceData] = useState<dropDown[]>([])
  const [likelihoodData, setLikelihoodData] = useState<dropDown[]>([])
  const [worktypeData, setWorktypeData] = useState<dropDown[]>([])
  const [employeeData, setEmployeeData] = useState<dropDown[]>([])
  const [employeeDataOrig, setEmployeeDataOrig] = useState<dropDown[]>([])
  const [matchSiteActive, setMatchSiteActive] = useState(false)
  const [clientId, setClientId] = useState(0)
  const [siteAddr, setSiteAddr] = useState({ text: '', value: 0 })
  const [contact, setContact] = useState({ text: '', value: 0 })
  const [isBadDebter, setIsBadDebter] = useState(false)


  const { showToast } = useToast()


  useEffect(() => {
    setWorktypeData(props.updatedWorkTypes)
  }, [props.updatedWorkTypes])

  useEffect(() => {
    const fetchSiteData = async () => {
      const siteData = await getSitesDropdown('')
      setSiteData(siteData)
      setSiteDataOrig(siteData)
    }

    const fetchClientData = async () => {
      const clientData = await getClientsDropdown('')
      setClientData(clientData)
      setClientDataOrig(clientData)
    }

    const fetchEnquirysourceData = async () => {
      const enquirysourceData = await getEnquirysourceDropdown()
      setEnquirysourceData(enquirysourceData)
    }

    const fetchLikelihoodData = async () => {
      const likelihoodData = await getLikelihoodDropdown()
      setLikelihoodData(likelihoodData)
    }

    const fetchWorktypeData = async () => {
      const worktypeData = await getWorktypeDropdown()
      setWorktypeData(worktypeData)
    }

    const fetchEmployeeData = async () => {
      const employeeData = await getEmployeeDropdown('')
      setEmployeeData(employeeData)
      setEmployeeDataOrig(employeeData)
    }

    fetchEmployeeData()
    fetchSiteData()
    fetchClientData()
    fetchEnquirysourceData()
    fetchLikelihoodData()
    fetchWorktypeData()
  }, [])

  const handleSubmit = (dataItem: any) => {
    dataItem.siteAddr = siteAddr
    dataItem.contact = contact
    dataItem.requireFollowups = dataItem.requireFollowups ?? true

    // alert(JSON.stringify(dataItem, null, 2));
    // console.log(dataItem);
    if (!dataItem.enquirysourceId){
      const newDataItem = {...dataItem, enquirysourceId: 0}
      props.onQuoteSubmit(newDataItem)
    }
    else {
      props.onQuoteSubmit(dataItem)
    }
  }

  //Search filters
  const searchSiteDropdown = (searchTerm: string) => {
    const fetchSiteData = async (search: string) => {
      await getSitesDropdown(search).then((result) => {
        setSiteData(result)
      })
    }

    fetchSiteData(searchTerm)
  }

  const searchClientDropdown = (searchTerm: string) => {
    const fetchClientData = async (search: string) => {
      await getClientsDropdown(search).then((result) => {
        setClientData(result)
      })
    }

    fetchClientData(searchTerm)
  }

  const searchEmployeeDropdown = (searchTerm: string) => {
    const fetchEmployeeData = async (search: string) => {
      await getEmployeeDropdown(search).then((result) => {
        setEmployeeData(result)
      })
    }

    fetchEmployeeData(searchTerm)
  }

  const handleAddSite = () => {
    props.onAddSiteToggle()
  }

  const handleAddWorkType = () => {
    props.onAddWorkTypeToggle()
  }

  const handleCheckSiteExists = async () => {
    if(matchSiteActive === true){
      await getMatchingClientSite(clientId).then((result) => {
        if (result !== null && result !== undefined) {
          const matchingId = (result as any).key
          console.log(matchingId)

          getTargetSite(matchingId).then((result) => {
            console.log(result)

            const newSiteObject = {
              value: result.siteId,
              text: result.siteAddr
            }

            console.log(newSiteObject)
            setSiteData([newSiteObject])
          })

          
          showToast('Site matched', 'success')
        } else {
          showToast('No matching site, try searching manually', 'error')
        }
      })
    } else {
      showToast('Select a client', 'error')
    }
  }

  const getAndStoreAddressesForCustomer = async (customerId: number) => {
    try { 
      const res = await getAddressesForClientDropdown(customerId);
      setSiteData(res);
      setSiteAddr({
        text: res.length === 1 ? res[0]?.text || '' : '',
        value: res.length === 1 ? res[0]?.value || 0 : 0,
      }
      );
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if(clientId !== 0) {
      getAndStoreAddressesForCustomer(clientId);
    }
  }, [clientId])  

  // Contacts for client
  const [contactsForClient, setContactsForClient] = useState<dropDown[]>([]);

  const getAndStoreContactsForCustomer = async (customerId: number) => {
    try {
      const res = await getClientsForClientsDropdown(customerId);
      setContactsForClient(res);
      setContact((prev: any) => ({
        text: res.length === 1 ? res[0]?.text || '' : '',
        value: res.length === 1 ? res[0]?.value || 0 : 0,
      }))

    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (clientId !== 0) {
      getAndStoreContactsForCustomer(clientId);
    }
  }, [clientId])

  const clearAccountFields = () => {
    setClientId(0);
    setSiteAddr({ text: '', value: 0 });
    setContact({ text: '', value: 0 });
  }


  return (
    <Form
      onSubmit={handleSubmit}
      render={(formRenderProps) => (
        <FormElement style={{ padding: '2rem', marginBottom: '5rem' }}>
          <fieldset className={'k-form-fieldset'}>
            <div className='form__subtitle'>
              Add quote details:
              <button
                className='form__reset__button'
                onClick={() => {formRenderProps.onFormReset(); clearAccountFields()}}
              >
                Clear fields
              </button>
            </div>

            <Divider>
              General Info
            </Divider>
            <Field
                      disabled={props.lockEdit}
                      data={clientData}
                      originalData={clientDataOrig}
                      name={'clientName'}
                      component={FormDropDownListFilter}
                      label={'Choose a client:'}
                      setData={setClientData}
                      searchDropdown={searchClientDropdown}
                      defaultItem={clientId}
                      onChange={(e) => {
                        const newClientId = parseInt(e.value.value, 10);
                        setClientId(newClientId);
                        // Check if client is bad debter
                        if (newClientId > 0) {
                          getClientByIdV2(newClientId).then((client) => {
                            setIsBadDebter(client.badDebter || false);
                          }).catch(() => {
                            setIsBadDebter(false);
                          });
                        } else {
                          setIsBadDebter(false);
                        }
                      }}
                      hasButton={props.lockEdit ? false : true}
                      buttonText={'Add Account'}
                      buttonAction={() => {
                        props.setAddAccountVisible(true)
                        props.setAccountMode("add");
                        props.setAccountInitialTab(0);
                      }}                    
                    />

<Field
                disabled={props.lockEdit}
                data={contactsForClient}
                originalData={siteDataOrig}
                name={'contact'}
                component={FormDropDownListFilter}
                label={'Contact:'}
                setData={setContactsForClient}
                onOpen={() => getAndStoreContactsForCustomer(clientId)}
                searchDropdown={searchSiteDropdown}
                defaultItem={contactsForClient.find(item => Number(item.value) === Number(contact.value))}
                onChange={(e) => {
                  setContact({
                    ...e.value,
                    contactId: parseInt(e.value.value, 10),
                  })
                }}
                hasButton={props.lockEdit ? false : clientId > 0}
                buttonText={'Add Contact'}
                buttonAction={() => {
                  props.setAccountMode("edit");
                  props.setSelectedAccountId(clientId);
                  props.setAccountInitialTab(2);
                  props.setAddAccountVisible(true)
                }}
              />
                    <Field
                      disabled={props.lockEdit}
                      data={siteData}
                      originalData={siteDataOrig}
                      name={'siteAddr'}
                      component={FormDropDownList}
                      label={'Address:'}
                      setData={setSiteData}
                      onOpen={() => getAndStoreAddressesForCustomer(clientId)}
                      searchDropdown={searchSiteDropdown}
                      defaultItem={siteData.find(item => Number(item.value) === Number(siteAddr.value))}
                      onChange={(e) => {
                        setSiteAddr({

                            ...e.value,
                            value: parseInt(e.value.value, 10),
                          },
                        )}}
                      hasButton={props.lockEdit ? false : clientId > 0}
                      buttonText={'Add Address'}
                      buttonAction={() => {
                        props.setAccountMode("edit");
                        props.setSelectedAccountId(clientId);
                        props.setAccountInitialTab(1);
                        props.setAddAccountVisible(true)
                      }}
                    />                                    

            {/* <Field
              data={clientData}
              originalData={clientDataOrig}
              name={'clientName'}
              component={FormDropDownListFilter}
              label={'Client:'}
              setData={setClientData}
              searchDropdown={searchClientDropdown}
              placeholder={'Choose a client:'}
              validator={requiredValidator}
              onChange={(e: any) => {
                setMatchSiteActive(true)
                setClientId(e.target.value.value)
              }}
            />

            <Field
              data={siteData}
              originalData={siteDataOrig}
              name={'siteAddr'}
              component={FormDropDownListFilter}
              label={'Site Address:'}
              setData={setSiteData}
              searchDropdown={searchSiteDropdown}
              placeholder={'Choose a site:'}
              validator={requiredValidator}
              hasButton={true}
              buttonText={'Add Site'}
              buttonAction={handleAddSite}
              hasSecondButton={true}
              secondButtonText={'Match site'}
              secondButtonAction={handleCheckSiteExists}
            /> */}

            <Field
              data={enquirysourceData}
              name={'enquirysourceId'}
              component={FormDropDownList}
              label={'Enquiry source:'}
              placeholder={'Choose enquiry source:'}
            />

            <Field
              data={likelihoodData}
              name={'likelihoodId'}
              component={FormDropDownList}
              label={'Likelihood:'}
              placeholder={'Choose likelihood:'}
            />

            <Field
              name={'description'}
              component={FormTextArea}
              label={'Description:'}
              placeholder={'Enter a description:'}
              validator={requiredValidator}
            />

            {isBadDebter && (
              <div style={{
                backgroundColor: '#fff3cd',
                border: '1px solid #ffc107',
                borderRadius: '4px',
                padding: '12px 16px',
                marginTop: '8px',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                color: '#856404'
              }}>
                <FaFlag style={{ fontSize: '18px', color: '#ffc107' }} />
                <span style={{ fontWeight: '600' }}>Contact accounts department</span>
              </div>
            )}

            <Divider>
              Quote Info
            </Divider>

            <Field
              data={worktypeData}
              name={'worktypeId'}
              component={FormDropDownList}
              label={'Type of Work:'}
              placeholder={'Choose a worktype:'}
              validator={requiredValidator}
              hasButton={true}
              buttonText={'Add Type of Work'}
              buttonAction={handleAddWorkType}
            />

          <div style={{display: "flex", flexDirection: "row",  alignItems: "center"}}>
            <p style={{margin: "0 1em 0 0", top: "20px", position: "relative"}}><b>£</b></p>
            <Field
              name={'cost'}
              component={FormNumericTextBox}
              label={'Value:'}
              placeholder={'Enter total value:'}
            />
          </div>

            <Field
              name={'followupDate'}
              component={FormDatePicker}
              label={'Due date:'}
              placeholder={'Due date:'}
              validator={requiredValidator}
            />

            <Field
              data={employeeData}
              originalData={employeeDataOrig}
              name={'employeeAssignedToId'}
              component={FormDropDownListFilter}
              searchDropdown={searchEmployeeDropdown}
              label={'Assigned to:'}
              setData={setEmployeeData}
              placeholder={'Choose an employee to assign:'}
            />

            <Field
              disabled={props.lockEdit}
              name={'requireFollowups'}
              component={FormSwitch}
              label={'Require Follow-ups'}
              defaultValue={true}
            />
          </fieldset>
          
          <div className='button__container'>
            <button
              type={'submit'}
              disabled={!formRenderProps.allowSubmit || (clientId === 0 || siteAddr.value === 0 || contact.value === 0)}
              className='form__addbutton'>
              Add quote
            </button>
          </div>
        </FormElement>
      )}
    />
  )
}

export default AddQuoteForm
